import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
import { trans } from '../config';
import { formatChord, isApplePlatform, parseBinding } from '../utils/keystroke';
/**
 * Renders a binding as `<kbd>` elements.
 *
 * Chords within a sequence are separated by a "then", alternatives by an "or",
 * so `g h` and `s, /` read as the different things they are. Modifiers use the
 * symbols the reader's own platform uses.
 *
 * The whole combo carries a plain-text `aria-label`, and the decorative
 * separators are hidden from assistive technology — otherwise a screen reader
 * would read "⇧ ⌘ K" as three unrelated letters.
 */
export default class KeyCombo extends Component {
  view(vnode) {
    const {
      binding,
      emptyLabel,
      className,
      ...attrs
    } = this.attrs;
    const parsed = parseBinding(binding);
    if (!parsed.length) {
      return m("span", Object.assign({
        className: classList('KeyCombo KeyCombo--empty', className)
      }, attrs), emptyLabel ?? trans('lib.unbound'));
    }
    const apple = isApplePlatform();
    return m("span", Object.assign({
      className: classList('KeyCombo', className),
      "aria-label": this.spoken(parsed, apple)
    }, attrs), parsed.map((sequence, alternative) => m("span", {
      className: "KeyCombo-alternative",
      "aria-hidden": "true"
    }, alternative > 0 && m("span", {
      className: "KeyCombo-separator"
    }, trans('lib.binding_or')), sequence.map((chord, step) => m("span", {
      className: "KeyCombo-chord"
    }, step > 0 && m("span", {
      className: "KeyCombo-separator"
    }, trans('lib.binding_then')), formatChord(chord, apple).map(key => m("kbd", {
      className: "KeyCombo-key"
    }, key)))))));
  }

  /**
   * The binding as a sentence, for assistive technology.
   */
  spoken(binding, apple) {
    const or = extractText(trans('lib.binding_or'));
    const then = extractText(trans('lib.binding_then'));
    return binding.map(sequence => sequence.map(chord => formatChord(chord, apple).join(' ')).join(` ${then} `)).join(` ${or} `);
  }
}
flarum.reg.add('datlechin-keyboard-shortcuts', 'common/components/KeyCombo', KeyCombo);